import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../graphql/fragments/generated/User';
export type ActionPlanResolvedOwner_DepartmentType_Fragment = { __typename: 'DepartmentType' };

export type ActionPlanResolvedOwner_UserType_Fragment = { __typename: 'UserType', id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null };

export type ActionPlanResolvedOwner_WorkspaceType_Fragment = { __typename: 'WorkspaceType' };

export type ActionPlanResolvedOwnerFragment = ActionPlanResolvedOwner_DepartmentType_Fragment | ActionPlanResolvedOwner_UserType_Fragment | ActionPlanResolvedOwner_WorkspaceType_Fragment;


export type ActionPlanResolvedOwnerFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ActionPlanResolvedOwnerFragmentDoc = /*#__PURE__*/ gql`
    fragment ActionPlanResolvedOwner on ActionPlanOwnerTypeUnion {
  ... on UserType {
    ...User
  }
  __typename
}
    `;